import { render, staticRenderFns } from "./BlogSinglePostAuthor.vue?vue&type=template&id=e2aa91b0&"
import script from "./BlogSinglePostAuthor.vue?vue&type=script&lang=ts&"
export * from "./BlogSinglePostAuthor.vue?vue&type=script&lang=ts&"
import style0 from "./BlogSinglePostAuthor.vue?vue&type=style&index=0&id=e2aa91b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports